//  @flow
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Page,
  Row,
  Col,
  Input,
  Button,
  Notification,
  DatePicker,
  Roller,
} from "components/Atoms";

import { RightOutlined } from "@ant-design/icons";

import * as Actions       from "actions/seller/seller.subscription";

import AvailablePlanCheckout  from "components/elements/seller/AvailablePlanCheckout";

import "./styles.scss";
import {useEffect} from "react";

const SubscriptionCheckout = (props) => {


  const {
    serviceError, reqStatus, isLoading,
    checkoutSubscriptionPlan, subscriptionCheckout
  } = props;

  useEffect(() => {
    checkoutSubscriptionPlan({ plan_id: "57e91523d360cc7622640d67" });
  }, []);

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  useEffect(() => {
    if (serviceError) {
      const feedback = {
        title: "Something went wrong!",
        description: serviceError.statusText,
      };
      sendNotification("error", feedback);
    }
    switch (reqStatus) {
      default:
        break;
    }
  }, [serviceError, reqStatus]);


    return (
      <Page className="page-checkout">
        <h4 className="page-title">Order Summary</h4>
        <div className="content">
          <div className="panel--white">
            <AvailablePlanCheckout
              plan={
                subscriptionCheckout.cart > 0
                  ? subscriptionCheckout.cart[0].plan_id
                  : ""
              }
            />
            <div className="split-row">
              <label>Subscription price</label>
              <p className="value">
                {subscriptionCheckout.total_original_price}
              </p>
            </div>
            <div className="split-row">
              <label>Delivery/Shipping</label>
              <p className="value">{subscriptionCheckout.total_shipping}</p>
            </div>
            <div className="split-row">
              <label>Discount</label>
              <p className="value">{subscriptionCheckout.promo_discount}</p>
            </div>
            <div className="split-row">
              <label className="text large">Total (after discount)</label>
              <p className="value text large bold">
                {subscriptionCheckout.total_after_discount}
              </p>
            </div>
            <hr />
            <div className="split-row savings">
              <label className="text large bold">Total Savings</label>
              <p className="value">$40</p>
            </div>
          </div>
          <div className="coupon-code">
            <Input
              size="large"
              className="input-code"
              placeholder="Enter Coupon Code"
            ></Input>
            <Button size="large" className="value">
              Apply
            </Button>
          </div>
          <h4> Payment Information</h4>
          <div className="panel--white payment">
            <div className="content">
              <h5>Payment Method</h5>
              <p className="value">Paytm</p>
            </div>
            <Button
              type="secondary"
              shape="circle"
              icon={<RightOutlined />}
              size="large"
            />
          </div>
          <Button type="primary" size="large" className="m-fit">
            Complete Payment
          </Button>
        </div>
      </Page>
    );
}
// Mapping Props and State.
const _SubscriptionCheckout = connect(
  ({ subscriptions, bootupInfo }) => ({
    bootupInfo: bootupInfo,
    reqStatus: subscriptions.reqStatus,
    isLoading: subscriptions.isLoading,
    serviceError: subscriptions.serviceError,
    subscriptionCheckout: subscriptions.subscriptionCheckout,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch)
)(SubscriptionCheckout);

export { _SubscriptionCheckout as default };
